// @ts-check
import SmrClient from "Utils/Requests/SmrClient";

class RecordRequests {
    /**
     * @returns {Promise<ProtocolInitDataResponse>}
     */
    async GetInitData() {
        return await SmrClient.FetchJson({
            url: 'Record/GetInitData',
            method: 'GET'
        });
    }

    /**
     * @param {LogFilterSet} filters
     * @returns {Promise<WebProtocolRecords>}
     */
    async GetData(filters) {
        return await SmrClient.FetchJson({
            url: 'Record/GetData',
            method: 'POST',
            body: filters
        });
    }

    /**
     * @param {number[]} logIds
     */
    async PrintSelectedLogs(logIds) {
        await SmrClient.FetchDownload({
            url: 'Record/PrintSelectedLogs',
            method: 'POST',
            body: logIds
        });
    }

    /**
     * @param {LogFilterSet} filters
     */
    async PrintFilteredLogs(filters) {
        await SmrClient.FetchDownload({
            url: 'Record/PrintFilteredLogs',
            method: 'POST',
            body: filters
        });
    }

    async PrintEnvironment() {
        await SmrClient.FetchDownload({
            url: 'Record/PrintEnvironment',
            method: 'GET'
        });
    }

    /**
     * @returns {Promise<VoidResponse>}
     */
    async ClearProtocol() {
        return await SmrClient.FetchJson({
            url: 'Record/ClearProtocol',
            method: 'GET'
        });
    }

    async GetLastProtocolArchive() {
        await SmrClient.FetchDownload({
            url: 'Record/GetLastProtocolArchive',
            method: 'GET'
        });
    }
}

export default new RecordRequests;